import Grid2 from '@mui/material/Grid2';
import Typography from '@mui/material/Typography';

import MealIcon from '../../../../mealPlanPage/MealIcon';
import { Meal } from '../../../../mealPlanPage/mealPlan.types';
import styles from './mealPerMealtypeContainingRecipe.module.css';

const MealsPerMealtypeContainingRecipe = ({ mealType, meals }: { mealType: string, meals: Meal[] }) => {

  if (!meals || !meals?.length) return null;
  const recipeNameList = meals.map(({ Recipes_E3: { name } }: any) => name).join(',');

  return <Grid2 className={styles.meals_container}>
    <MealIcon height={40} mealType={mealType} width={40} />
    <Grid2 className={styles.meals_wrapper}>
      <Grid2 className={styles.meal_recipes}>
        <Typography noWrap variant="caption4LightOutfit">
          {recipeNameList}
        </Typography>
      </Grid2>
      <Typography className={styles.has_recipe_text} variant='caption4Outfit'>This recipe is already added for the day</Typography>
    </Grid2>
  </Grid2>
}

export default MealsPerMealtypeContainingRecipe